var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: "Overview" } },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.nameLabel } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.selectPlaceholder },
                          on: { change: _vm.getTableData },
                          model: {
                            value: _vm.form.seId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "seId", $$v)
                            },
                            expression: "form.seId",
                          },
                        },
                        _vm._l(_vm.seList, function (item) {
                          return _c("el-option", {
                            key: item.SEID,
                            attrs: { label: item.Name, value: item.SEID },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Duration" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Please select duration" },
                          on: { change: _vm.getTableData },
                          model: {
                            value: _vm.form.dateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dateRange", $$v)
                            },
                            expression: "form.dateRange",
                          },
                        },
                        _vm._l(_vm.dateRanges, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                "element-loading-text": "Loading...",
                "header-row-class-name": "table-header",
                "row-class-name": "table-row",
              },
            },
            [
              _vm._l(_vm.columns, function (item, i) {
                return [
                  _c("el-table-column", {
                    key: i,
                    attrs: {
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.minWidth,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              item.hash
                                ? _c(
                                    "router-link",
                                    { attrs: { to: _vm.toPath(row, item) } },
                                    [_vm._v(" " + _vm._s(row[item.prop]) + " ")]
                                  )
                                : item.prop == "Type"
                                ? [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.types
                                            ? row.types
                                                .map((item) => item.TypeDesc)
                                                .join(",")
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                : [_vm._v(" " + _vm._s(row[item.prop]) + " ")],
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      false
        ? [
            _c(
              "PageHeader",
              { attrs: { title: "My Message Board" } },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.isActive,
                      callback: function ($$v) {
                        _vm.isActive = $$v
                      },
                      expression: "isActive",
                    },
                  },
                  [_vm._v("Active")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "iconfont icon-save" },
                    on: { click: _vm.onSave },
                  },
                  [_vm._v(" Save ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { plain: "", icon: "el-icon-refresh-left" },
                    on: { click: _vm.onReset },
                  },
                  [_vm._v(" Cancel ")]
                ),
              ],
              1
            ),
            _c("TinymceEditor", {
              on: { onSave: _vm.onSave },
              model: {
                value: _vm.text,
                callback: function ($$v) {
                  _vm.text = $$v
                },
                expression: "text",
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }